var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrd001DetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Show"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3616 8.05311C13.3616 9.79911 11.9456 11.2141 10.1996 11.2141C8.45357 11.2141 7.03857 9.79911 7.03857 8.05311C7.03857 6.30611 8.45357 4.89111 10.1996 4.89111C11.9456 4.89111 13.3616 6.30611 13.3616 8.05311Z",
    stroke: "#605BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1982 15.355C14.0062 15.355 17.4892 12.617 19.4502 8.05298C17.4892 3.48898 14.0062 0.750977 10.1982 0.750977H10.2022C6.3942 0.750977 2.9112 3.48898 0.950195 8.05298C2.9112 12.617 6.3942 15.355 10.2022 15.355H10.1982Z",
    stroke: "#605BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrd001DetailIcon);
export default __webpack_public_path__ + "static/media/ord_001_detail_icon.9474efffe6aea66826ed42dfc2d10f57.svg";
export { ForwardRef as ReactComponent };